import React, { Component, Fragment } from 'react'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui-icons/MoreVert'
import FeedbackDialog from '../FeedbackDialog'
import Menu, { MenuItem } from 'material-ui/Menu'
import { ListItemIcon, ListItemText } from 'material-ui/List'
import FeedbackIcon from 'material-ui-icons/Feedback'

type State = {
  menuAnchorEl: any,
  openFeedbackDialog: boolean
}

class AppMenu extends Component<void, State> {
  state = {
    menuAnchorEl: null,
    openFeedbackDialog: false
  }

  handleClickMoreVertIcon = e => {
    this.setState({
      menuAnchorEl: e.currentTarget
    })
  }

  handleCloseMenu = () => {
    this.setState({
      menuAnchorEl: null
    })
  }

  handleCloseFeedbackDialog = () => {
    this.setState({
      openFeedbackDialog: false
    })
  }

  handleClickMenuItem = () => {
    this.setState({
      openFeedbackDialog: true,
      menuAnchorEl: null
    })
  }

  render() {
    const {
      menuAnchorEl,
      openFeedbackDialog,
    } = this.state

    return (
      <Fragment>
        <IconButton
          color='inherit'
          aria-label='Menu'
          onClick={this.handleClickMoreVertIcon}
        >
          <MoreVertIcon />
        </IconButton>

        <Menu
          open={Boolean(menuAnchorEl)}
          onClose={this.handleCloseMenu}
          anchorEl={menuAnchorEl}
        >
          <MenuItem onClick={this.handleClickMenuItem}>
            <ListItemIcon>
              <FeedbackIcon />
            </ListItemIcon>
            <ListItemText
              primary='Submit Feedback'
            />
          </MenuItem>
        </Menu>

        <FeedbackDialog
          open={openFeedbackDialog}
          onClose={this.handleCloseFeedbackDialog}
        />
      </Fragment>
    )
  }
}

export default AppMenu



// WEBPACK FOOTER //
// ./src/components/AppMenu/AppMenu.js